<template>
  <footer class="footer mt-5 p-4 text-center">
    <ul class="list-inline">
      <li class="list-inline-item mx-3">
        <LinkItem
          title="情報セキュリティ"
          href="https://www.softbank.jp/corp/aboutus/governance/security/"
          color="black"
        />
      </li>
      <li class="list-inline-item mx-3">
        <LinkItem
          title="個人情報の取り扱いについて"
          href="https://www.softbank.jp/corp/privacy/"
          color="black"
        />
      </li>
      <li class="list-inline-item mx-3">
        <LinkItem
          title="グループ各社の約款・重要事項"
          href="https://www.softbank.jp/help/legal/"
          color="black"
        />
      </li>
      <li class="list-inline-item mx-3">
        <LinkItem
          title="サイトポリシー"
          href="https://www.softbank.jp/help/sitepolicy/"
          color="black"
        />
      </li>
      <li class="list-inline-item mx-3">
        <LinkItem
          title="プライバシーセンター"
          href="https://www.softbank.jp/privacy/"
          color="black"
        />
      </li>
      <li class="list-inline-item mx-3">
        <LinkItem
          title="特定商取引法に基づく表示"
          href="https://www.softbank.jp/mobile/support/online-shop/tokutei/"
          color="black"
        />
      </li>
      <li class="list-inline-item mx-3">
        <LinkItem
          title="サイトマップ"
          href="https://www.softbank.jp/sitemap/"
          color="black"
        />
      </li>
    </ul>
    <p class="m-0">
      <small>Copyright &copy; SoftBank Group All rights reserved.</small>
    </p>
  </footer>
</template>

<style scoped>
  .footer {
    background-color: lightgray;
    color: black;
  }
</style>
